import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useApi } from "../../../hooks/useApi";
import api from "../../../utils/api";
import "./Products.scss";

const Products = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const { data, loading, refetch } = useApi(
    () => api.getAdminProducts({ limit: 50, search: searchTerm }),
    [searchTerm]
  );

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this product?")) {
      try {
        await api.deleteProduct(id);
        refetch();
      } catch (error) {
        console.error("Error deleting product:", error);
        alert("Failed to delete product");
      }
    }
  };

  const products = data?.products || [];
  const filteredProducts = products.filter((product) =>
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="admin-products">
      <div className="products-header">
        <div className="search-box">
          <input
            type="text"
            placeholder="Search products..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <Link to="/admin/products/new" className="btn-primary">
          Add New Product
        </Link>
      </div>

      {loading ? (
        <div className="loading">Loading products...</div>
      ) : (
        <div className="products-table">
          <table>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Price</th>
                <th>Stock</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredProducts.length === 0 ? (
                <tr>
                  <td colSpan="6" className="empty-state">
                    No products found
                  </td>
                </tr>
              ) : (
                filteredProducts.map((product) => (
                  <tr key={product.id}>
                    <td>{product.productId}</td>
                    <td>{product.name}</td>
                    <td>
                      {product.onSale ? (
                        <>
                          <span className="sale-price">${product.salePrice}</span>
                          <span className="regular-price">${product.regularPrice}</span>
                        </>
                      ) : (
                        `$${product.price || product.regularPrice}`
                      )}
                    </td>
                    <td>{product.stockQuantity || 0}</td>
                    <td>
                      <span
                        className={`status-badge ${
                          product.stockStatus === "IN_STOCK"
                            ? "in-stock"
                            : "out-of-stock"
                        }`}
                      >
                        {product.stockStatus || "IN_STOCK"}
                      </span>
                    </td>
                    <td>
                      <div className="action-buttons">
                        <Link
                          to={`/admin/products/${product.id}/edit`}
                          className="btn-edit"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() => handleDelete(product.id)}
                          className="btn-delete"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Products;
